import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Deal } from 'app/models/dto/deal.model';
import { DealState } from 'ng2-app/store/deal/deal/deal.state';
import { Observable, Subject } from 'rxjs';
import { GetDeals } from 'ng2-app/store/deal/deal/deal.actions';
import { BorrowerState } from 'app/store/borrower/borrower/borrower.state';
import { GetApprovals } from 'ng2-app/store/offers/approvals.actions';

@Component({
  selector: 'app-borrower-pane-deals',
  templateUrl: './borrower-pane-deals.component.html',
  styleUrls: ['./borrower-pane-deals.component.scss'],
  standalone: false
})
export class BorrowerPaneDealsComponent implements OnInit, OnDestroy {

  //selectors
  @Select(BorrowerState.borrowerId) borrowerId$: Observable<number>;
  @Select(DealState.activeDeals) deals$: Observable<Deal[]>;
  @Select(DealState.loading) dealsLoading$: Observable<boolean>;

  //inputs
  @Input() borrowerId: number;

  //attributes
  destroyed$ = new Subject<boolean>();

  activeColumns = [
    'expand',
    'lenderProduct',
    'offerAmount',
    'offerRate',
    'offerTerm',
    'offerFrequency',
    'offerPoints',
    'status',
  ];


  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.store.dispatch( new GetDeals(this.borrowerId, true) );
    this.store.dispatch( new GetApprovals(this.borrowerId) );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
